import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AppService } from '../../../app.service';
import { TravelersService } from '../travelers.service';

@Component({
  selector: 'app-disabled-login-form',
  templateUrl: './disabled-login-form.component.html'
})
export class DisabledLoginFormComponent implements OnInit {

  alreadyLoginError: string;
  loggedInUsername: string;
  samplePassword = 'samplePassword';

  @Output() openSasTnc: EventEmitter<any> = new EventEmitter();
  @Output() openViasatTnc: EventEmitter<any> = new EventEmitter();

  constructor(
    private appService: AppService,
    private travelersService: TravelersService) { }

  ngOnInit() {
    setTimeout(() => {
      this.loggedInUsername = this.appService.getLoggedInUsername();
      this.alreadyLoginError = this.travelersService.getAlreadyLoginErrorCode();
    }, 0);
  }

  openSasTnC() {
    this.openSasTnc.emit()
  }

  openViasatTnC() {
    this.openViasatTnc.emit()
  }

}
